import * as types from './currencyActionTypes';

export const getCurrencyRequestAction = (payload) => ({
  type: types.GET_CURRENCY_REQUEST,
  payload,
});
export const getCurrencyDataAction = (payload) => ({
  type: types.GET_CURRENCY_DATA,
  payload,
});
export const getCurrencyErrorAction = (payload) => ({
  type: types.GET_CURRENCY_ERROR,
  payload,
});

export const createCurrencyRequestAction = (payload) => ({
  type: types.CREATE_CURRENCY_REQUEST,
  payload,
});
export const createCurrencyDataAction = (payload) => ({
  type: types.CREATE_CURRENCY_DATA,
  payload,
});
export const createCurrencyErrorAction = (payload) => ({
  type: types.CREATE_CURRENCY_ERROR,
  payload,
});

export const updateCurrencyRequestAction = (payload) => ({
  type: types.UPDATE_CURRENCY_REQUEST,
  payload,
});
export const updateCurrencyDataAction = (payload) => ({
  type: types.UPDATE_CURRENCY_DATA,
  payload,
});
export const updateCurrencyErrorAction = (payload) => ({
  type: types.UPDATE_CURRENCY_ERROR,
  payload,
});

export const deleteCurrencyRequestAction = (payload) => ({
  type: types.DELETE_CURRENCY_REQUEST,
  payload,
});
export const deleteCurrencyDataAction = (payload) => ({
  type: types.DELETE_CURRENCY_DATA,
  payload,
});
export const deleteCurrencyErrorAction = (payload) => ({
  type: types.DELETE_CURRENCY_ERROR,
  payload,
});
